import Splide from '@splidejs/splide';
// import AutoScroll from '@splidejs/splide-extension-auto-scroll';

$(function () {
  if( $('.splide.topMv-slide').length > 0 ) {
    new Splide(".splide.topMv-slide", {
      type: "fade",
      gap: 0,
      arrows: false,
      interval: 5000,
      pagination: false,
      autoplay: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      rewind: true,
    }).mount();
  }

  if( $('.splide.splide-sec02').length > 0 ) {
    new Splide(".splide.splide-sec02", {
      type: "loop",
      gap: 30,
      autoWidth: true,
      // perPage: 2,
      arrows: true,
      pagination: false,
      breakpoints: {
      768: {
        // fixedWidth: "265px",
          focus: "center",
        },
      },
    }).mount();
  }
});

$(function () {
  if( $('.splide.splide-sec08').length > 0 ) {
    new Splide(".splide.splide-sec08", {
      type: "loop",
      gap: 30,
      autoWidth: true,
      // perPage: 2,
      arrows: true,
      pagination: false,
      breakpoints: {
        768: {
          gap: 20,
        },
      },
      breakpoints: {
        428: {
          pagination: true,
        },
      },
    }).mount();
  }
});

$(function () {
  if( $('.splide.splide-sec12').length > 0 ) {
    const options = {
      fixedWidth: "100%",
      type: "loop",
      gap: '25px',
      arrows: false,
      drag: false,
      flickPower: 100,
      pagination: false,
      autoScroll: {
        speed: 1,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
      breakpoints: {
        768: {
          fixedWidth: "1220px",
        },
      },
    };
    const splide = new Splide(".splide.splide-sec12", options);
    splide.mount(window.splide.Extensions);
  }
});

$(function () {
  if( $('.splide.splide-sec17').length > 0 ) {
    const options = {
      fixedWidth: "480px",
      type: "loop",
      gap: '0',
      arrows: false,
      drag: false,
      flickPower: 100,
      pagination: false,
      autoScroll: {
        speed: 1,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
      breakpoints: {
        768: {
          fixedWidth: "240px",
        },
      },
    };
    const splide = new Splide(".splide.splide-sec17", options);
    splide.mount(window.splide.Extensions);
  }
});
